import Resource from '@/plugins/sdk/Resource'
import { STRING, BOOLEAN, UUID, DATETIME, ITEM } from '@/plugins/sdk/fields'
import File from '../File'

export default class extends Resource {
  static name = 'scan'

  static get fields () {
    return {
      id: new UUID(),
      text: new STRING(),
      depot: new STRING(),
      signed_by: new STRING(),
      scanned_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted_date: new DATETIME(),
      deleted: new BOOLEAN(),
      proof_of_delivery: new ITEM(File)
    }
  }
}
